<template>
	<div class="jump-to-latest">
		<ArrowDownIcon v-if="!loading" />
		<IosSpinner v-if="loading" />
	</div>
</template>

<script>
import IosSpinner from '@/components/IosSpinner'
import { ArrowDownIcon } from '@/icons'

export default {
	components: { ArrowDownIcon, IosSpinner },
	props: { loading: { type: Boolean, default: null } },
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.jump-to-latest {
	$size: 30px;
	$half: 15px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	position: absolute;
	z-index: 999;
	bottom: 25px;
	left: calc(50% - #{$half});
	height: $size;
	width: $size;
	border-radius: 20px;
	background: var(--teal-300);
	color: var(--neutral-0);

	:deep(.ios-spinner) {
		width: 30px !important;
		height: 30px !important;
		background: transparent !important;
		margin-top: 0 !important;
		margin-left: -2px !important;
		> div {
			background: white !important;
		}
	}
}
</style>
